import { useQuery } from "@tanstack/react-query";

import { pessoaService } from "@/services/api/PessoaService";
import { PessoaOnlineDTO } from "@/types/pessoa-acesso.type";

const REAVALIA_A_CADA_MS = 60_000;

/** Refetch a cada minuto: quem está online muda com o tempo, diferente da lista de férias. */
export function usePessoasOnline() {
  const { data, isLoading } = useQuery<PessoaOnlineDTO[]>({
    queryKey: ["pessoas-online"],
    queryFn: () => pessoaService.getPessoasOnline(),
    refetchInterval: REAVALIA_A_CADA_MS,
  });

  return { pessoas: data ?? [], loading: isLoading };
}
